/* Terjung product/category rail behaviour. Static asset generated from the live rail snippet. */
(() => {
    const initRail = (section) => {
      const scroller = section && section.querySelector('[data-terjung-product-category-scroller]');
      if (!scroller || scroller.dataset.terjungProductCategoryRailReady === 'true') return;
      scroller.dataset.terjungProductCategoryRailReady = 'true';
      const previous = section.querySelector('[data-terjung-product-category-prev]');
      const next = section.querySelector('[data-terjung-product-category-next]');
      const updateControls = () => {
        const canScroll = scroller.scrollWidth > scroller.clientWidth + 2;
        const atStart = scroller.scrollLeft <= 2;
        const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
        if (previous) previous.hidden = !canScroll || atStart;
        if (next) next.hidden = !canScroll || atEnd;
      };
      const scrollByPage = (direction) => {
        scroller.scrollBy({ left: direction * Math.max(240, scroller.clientWidth * .72), behavior: 'smooth' });
      };
      previous && previous.addEventListener('click', () => scrollByPage(-1));
      next && next.addEventListener('click', () => scrollByPage(1));
      scroller.addEventListener('scroll', () => window.requestAnimationFrame(updateControls), { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    };

    document.querySelectorAll('[data-terjung-product-category-rail]').forEach(initRail);
  })();
